/** @file writeChunk: serialises one PNG chunk (length, type, data, CRC). */
import { crc32 } from '../zlib/crc32';

/** `length` (big-endian) + 4-byte ASCII `type` + `data` + `crc32(type + data)`. */
export function writeChunk(type: string, data: Uint8Array): Uint8Array {
  const out = new Uint8Array(12 + data.length);
  const dv = new DataView(out.buffer);
  dv.setUint32(0, data.length);
  for (let i = 0; i < 4; i++) out[4 + i] = type.charCodeAt(i);
  out.set(data, 8);
  dv.setUint32(8 + data.length, crc32(out.subarray(4, 8 + data.length)));
  return out;
}
